import { theme } from '@/index';
import { StyledContainer, StyledLeftSection, StyledLogo } from './HeaderNoPermissonsV2.styles';
import CustomLogoIcon from '../HeaderV2/CustomLogoV2/CustomLogoV2';

const HeaderNoPermissonsV2 = () => (
    <StyledContainer container>
        <StyledLeftSection size={6}>
          <StyledLogo> 
            <CustomLogoIcon 
             style={{ fontSize: '20px', width: '120px', color: theme.palette.secondary.main }}
            />
          </StyledLogo>
        </StyledLeftSection>
      </StyledContainer>
  )


export default HeaderNoPermissonsV2









